import { render, staticRenderFns } from "./Pressure.vue?vue&type=template&id=64978bc8&scoped=true&"
import script from "./Pressure.vue?vue&type=script&lang=js&"
export * from "./Pressure.vue?vue&type=script&lang=js&"
import style0 from "./Pressure.vue?vue&type=style&index=0&id=64978bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64978bc8",
  null
  
)

export default component.exports